"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Input = void 0;
var _faExclamationTriangle = require("@fortawesome/free-solid-svg-icons/faExclamationTriangle");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _core = require("@material-ui/core");
var _react = _interopRequireDefault(require("react"));
var _Flag = require("../Flag");
var _Tooltip = require("../Tooltip");
var _Icon = require("./Components/Icon");
var _Input = require("./Input.styles");
var _excluded = ["className", "testId", "inputProps", "InputProps", "currencyType"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var Input = function Input(props) {
  var classes = (0, _Input.useStyles)({
    currencyInput: props.currency && props.currency,
    detailsModal: props.detailsModal && props.detailsModal
  });
  var _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    testId = props.testId,
    _props$inputProps = props.inputProps,
    inputProps = _props$inputProps === void 0 ? {} : _props$inputProps,
    InputProps = props.InputProps,
    currencyType = props.currencyType,
    rest = _objectWithoutProperties(props, _excluded);
  var component = /*#__PURE__*/_react["default"].createElement(_core.TextField, _extends({
    className: "UiInput ".concat(className, " ").concat(classes.root),
    inputProps: _objectSpread(_objectSpread({}, inputProps), {}, _defineProperty({}, "data-testid", testId)),
    InputProps: _objectSpread(_objectSpread({}, InputProps), {}, {
      endAdornment: InputProps !== null && InputProps !== void 0 && InputProps.endAdornment ? /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
        wrapVariant: props.variant,
        wrap: props.variant === 'outlined' || props.variant === 'filled',
        position: "right"
      }, InputProps.endAdornment) : props.warning ? /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
        icon: _faExclamationTriangle.faExclamationTriangle,
        className: classes.warningIcon
      }) : undefined,
      startAdornment: InputProps !== null && InputProps !== void 0 && InputProps.startAdornment || props.currency ? /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
        onClick: props.startAdornmentOnClick || undefined,
        wrapVariant: props.variant,
        wrap: props.variant === 'outlined' || props.variant === 'filled',
        position: "left"
      }, InputProps === null || InputProps === void 0 ? void 0 : InputProps.startAdornment, props.currency && /*#__PURE__*/_react["default"].createElement("div", {
        className: "currencyAdornment"
      }, /*#__PURE__*/_react["default"].createElement("span", null, props.currency), /*#__PURE__*/_react["default"].createElement(_Flag.Flag, {
        code: props.currency,
        size: "sm"
      }))) : undefined
    })
  }, rest));
  if (props.warning) {
    return /*#__PURE__*/_react["default"].createElement(_Tooltip.Tooltip, {
      title: props.warning
    }, /*#__PURE__*/_react["default"].createElement("div", null, component));
  }
  if (props.currency) {
    var label = "".concat(currencyType, " Amount");
    return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("p", {
      className: classes.currencyLabel
    }, label), /*#__PURE__*/_react["default"].createElement("div", null, component));
  }
  return component;
};
exports.Input = Input;